import { useQuery } from '@tanstack/react-query';
import { fetchFileStatistics } from '@/api/files';

export const fileStatsKeys = {
  all: ['file-statistics'] as const,
};

export function useFileStatistics() {
  return useQuery({
    queryKey: fileStatsKeys.all,
    queryFn: fetchFileStatistics,
    staleTime: 60_000,
  });
}
